import script from "./PageOrganization.vue?vue&type=script&setup=true&lang=js"
export * from "./PageOrganization.vue?vue&type=script&setup=true&lang=js"

import "./PageOrganization.vue?vue&type=style&index=0&id=79067fe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79067fe2"]])

export default __exports__